import CalcStepper from "@/components/sections/calculator/CalcStepper";

const MAX_UNITS = 10;

export default function CalcControls({ c, state, actions }) {
  const { indoor, outdoor, high, far } = state;
  const { setIndoor, setOutdoorClamped, setHigh, setFar } = actions;

  return (
    <div>
      <CalcStepper label={c.indoor} hint={c.indoorHint} value={indoor} min={1} max={MAX_UNITS} onChange={setIndoor} testId="calc-indoor" />
      <CalcStepper label={c.outdoor} hint={c.outdoorHint} value={outdoor} min={0} max={MAX_UNITS} onChange={setOutdoorClamped} testId="calc-outdoor" />
      <CalcStepper label={c.high} hint={c.highHint} value={high} min={0} max={outdoor} onChange={setHigh} testId="calc-high" />
      <label className="flex items-start gap-3 py-4 cursor-pointer">
        <input
          type="checkbox"
          checked={far}
          onChange={(e) => setFar(e.target.checked)}
          className="mt-0.5 w-5 h-5 shrink-0 accent-[var(--secondary)]"
          data-testid="calc-far-checkbox"
        />
        <span>
          <span className="font-semibold text-[var(--heading)] block">{c.far}</span>
          <span className="text-xs text-[var(--muted)]">{c.farHint}</span>
        </span>
      </label>
      <a
        href="/fan-coil"
        className="block mt-2 p-4 rounded-xl border border-dashed border-[var(--primary)]/40 bg-[var(--primary)]/5 hover:bg-[var(--primary)]/10 transition-colors"
        data-testid="calc-fancoil-link"
      >
        <span className="font-semibold text-[var(--heading)] block">{c.fancoil.label}</span>
        <span className="text-xs text-[var(--muted)] block mt-0.5">{c.fancoil.body}</span>
        <span className="text-sm font-bold text-[var(--primary)] inline-flex items-center gap-1 mt-2">
          {c.fancoil.cta} →
        </span>
      </a>
    </div>
  );
}
